// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.search-results{margin-left:auto;margin-right:auto}@media(min-width:768px){.search-results{max-width:80%}}@media(min-width:1100px){.search-results{max-width:none}}.search-results__item+.search-results__item{border-top:1px solid rgba(0,0,0,.25);margin-top:clamp(1.875rem,.9375rem + 3.125vw,4.0625rem);padding-top:clamp(1.875rem,.9375rem + 3.125vw,4.0625rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
